module.exports = __webpack_public_path__ + "img/9791155640289.b69cb708.jpg";